import styled, { css } from 'styled-components';
import { HiddenElement } from '@/styles/helpers';
import { Header as HeaderComponent } from '@/components/Header/Header';
import type { AdsSectionLayoutScope } from '@/components/AdsSection/AdsSection.types';

export const Header = styled(HeaderComponent)`
  border-bottom: none;
`;

const wrapperStyles = css`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 30px;
  background: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
  }
`;

const containerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1280px;

  & > * {
    width: 100%;
  }
`;

export const AllCategoriesWrapper = styled.div`
  ${wrapperStyles};
`;

export const CategoryWrapper = styled.div`
  ${wrapperStyles};
`;

export const SubcategoryWrapper = styled.div`
  ${wrapperStyles};
`;

export const AllCategoriesContainer = styled.div`
  ${containerStyles};
`;

export const CategoryContainer = styled.div`
  ${containerStyles};
`;

export const SubcategoryContainer = styled.div`
  ${containerStyles};
`;

export const layoutComponents = {
  'all-categories': {
    Wrapper: AllCategoriesWrapper,
    Container: AllCategoriesContainer,
  },
  category: {
    Wrapper: CategoryWrapper,
    Container: CategoryContainer,
  },
  subcategory: {
    Wrapper: SubcategoryWrapper,
    Container: SubcategoryContainer,
  },
} satisfies Record<
  AdsSectionLayoutScope,
  {
    Wrapper: typeof AllCategoriesWrapper;
    Container: typeof AllCategoriesContainer;
  }
>;

export const FooterBox = styled.div<{ $isVisible: boolean }>`
  ${({ $isVisible }) => ($isVisible ? '' : HiddenElement)};
`;
